export default __webpack_public_path__ + "static/media/fa-brands-400.469f3e19.woff";